import {
  Button,
  Input,
  Stack,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdOutlineAttachFile } from "react-icons/md";
import { AiOutlineSend } from "react-icons/ai";
import { useRef, useState } from "react";
import EmojiSelector from "../../components/EmojiSelector";
import dayjs from "dayjs";
import { useGetState } from "../../context/useGetState";
import { useEffect } from "react";
import { useDeferredValue } from "react";
import useSmallScreen from "../../components/useSmallScreen";
const AWS = require("aws-sdk");

let utc = require("dayjs/plugin/utc");

dayjs.extend(utc);

function MessageBox({
  width,
  chatContext,
  userDetails,
  handleSendMsg,
  handleSendFile,
  currentChat,
  socket,
  typingUserId,
  ...props
}) {
  const inputBg = useColorModeValue("#fff", "#030c1d");

  const [message, setMessage] = useState("");
  const [img, setImg] = useState("");
  const { state } = useGetState();
  const loggedInUser = state?.userInfo;
  const imgRef = useRef();
  const [disabled, setDisabled] = useState(true);
  const [msg, setMsg] = useState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [file, setFile] = useState();
  const [typingStatus, setTypingStatus] = useState("");
  const [placeholderText, setPlaceholderText] = useState(
    "Enter your message here"
  );
  const [newPlaceholder, setNewPlaceholder] = useState();

  //console.log('loggedInUser: ', loggedInUser);

  const deferredInput = useDeferredValue(message);
  const [smallScreen] = useSmallScreen();
  const chatBg = useColorModeValue("#f9fafc", "#030c1b");

  // Create a ref for the chat input field
  const chatInputField = useRef(null);

  const sendChat = (event) => {
    event.preventDefault();
    if (msg.length > 0) {
      handleSendMsg(msg, "Text");
      setMsg("");
    }
  };

  function onClick(emojiData, event) {
    setMsg((prev) => `${prev} ${emojiData.emoji}`);
  }
  const mobileChatBoxStyles = {
    position: " fixed",
    bottom: "6vh",
    left: 0,
    right: 0,
    width: "100%",
    background: chatBg,
    height: " 100px",
    borderRadius: "unset",
    zIndex: "9999",
  };

  const selectFile = (e) => {
    const selectedFile = e.target.files[0]
    console.log('uploadedFile: ', selectedFile);
    setFile(selectedFile)
    const formData = new FormData();
    formData.append("file", selectedFile);
    handleSendFile(selectedFile, "Image");
    setMsg("");
  };
  const handleTyping = (e) => {
    let theText = e.target.value;
    //console.log("typingUserId: ", "lorem");
    if (theText.length < 1) {
      setPlaceholderText("Enter your message here");
    } else {
      const eventData = [
        {
          senderId: loggedInUser?.id,
          senderName: loggedInUser?.name,
        },
        {
          receiverId: currentChat?.recipient?.id,
          receiverName: currentChat?.recipient?.name,
        },
      ];

      socket.current.emit("typing", eventData);
    }
  };
  useEffect(() => {
    socket?.current?.on("typingResponse", (typingEventData) => {
      let senderName = typingEventData[0].senderName;
      let receiverId = typingEventData[1].receiverId;
      receiverId === loggedInUser?.id
        ? setPlaceholderText(`${senderName} is typing...`)
        : setPlaceholderText("Enter your message here");
    });
  }, [placeholderText]);

  //console.log("width", width, props.isOpen);

  return (
    <>
      
      <Stack
        position={["absolute", "fixed"]}
        bottom={["0px", "30px"]}
        // w={"53%"}
        w={props.isOpen ? "53%" : "75%"}
        // w={["100%", width - 30]}
        // w={"75%"}
        direction="row"
        alignItems={"center"}
        bg={inputBg}
        borderRadius={"35px"}
        p="5px"
        {...(smallScreen ? mobileChatBoxStyles : {})}
      >
        <style>
          {`
      /* Hide scrollbar for Chrome, Safari and Opera */
      .textarea-scroll::-webkit-scrollbar {
        display: none;
      }

      /* Hide scrollbar for IE, Edge and Firefox */
      .textarea-scroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }
`}
        </style>

        <Textarea
          ref={chatInputField}
          className="scroll-container textarea-scroll"
          rows="1"
          size={"sm"}
          placeholder={placeholderText}
          type="text"
          bg={inputBg}
          onChange={(e) => {
            const typedMsg = e.target.value;
            setMsg(typedMsg);
          }}
          onFocus={(e) => {
            handleTyping(e);
          }}
          value={msg}
          border="none"
        />
        <Stack
          direction={"row"}
          alignItems="center"
          ml="-80px"
          mt="20px"
          bg={inputBg}
        >
          <EmojiSelector onClick={onClick} />
          <Input
            display={"none"}
            type="file"
            name="file"
            accept="image/jpg, image/jpeg, image/png"
            ref={imgRef}
            onChange={selectFile}
          />

          <MdOutlineAttachFile
            cursor={"pointer"}
            onClick={() => imgRef.current?.click()}
            color="#AFBBC6"
            fontSize={"1.5em"}
          />
          <Button
            bg="#50BB69"
            _hover={{ background: "#50BB69" }}
            color="#fff"
            p="3px"
            borderRadius={"50%"}
            onClick={sendChat}
            cursor="pointer"
          >
            <AiOutlineSend fontSize={".9em"} />
          </Button>
        </Stack>
      </Stack>
    </>
  );
}

export default MessageBox;
